export default __webpack_public_path__ + "static/media/forest-image-mobile.d343e6da.png";